import React from 'react';

/**
 * DetailImpactRightText
 * 
 * Displays the right textual content for the Sustainability (Impact) section.
 * Shows either the Synthetic Alternative Estimate or Tree Sequestration stats.
 */
export const DetailImpactRightText = ({ impactData, t, hideCalculator }) => {
  if (!impactData) return null;

  if (!hideCalculator) {
    const calculateImpactReduction = (alliedValue, synthValue) => {
      if (!synthValue || synthValue === 0) return "N/A";    
      const reduction = (1 - (alliedValue / synthValue)) * 100;
      const whole = Math.floor(reduction);            
      if (reduction > whole) {return whole + "⁺%";}    
      return whole + "%";
    };

    const synthPercent = calculateImpactReduction(impactData.total, 0.00848);

    return (
      <>
        {/* Commented out original:
        <div className="mr-synth-score">
          <p className="spec-title">{t("impact.synthetic_alternative_estimate")}</p>
          <p className="spec-value">0.00848</p>
          <p className="spec-measure">{t("impact.kg_co2")}</p>
        </div>
        */}
        <div className="mr-synth-score">
          <p className="spec-title">{t("impact.lower_impact")}</p>
          <p className="spec-value">{synthPercent}</p>
          <p className="spec-measure">{t("impact.than_synthetic")}</p>
        </div>
      </>
    );
  } else {
    // Tree Sequestration logic
    const treeVal = ((impactData.total * 140) * 17).toFixed(2);
    return (
      <div className="mr-synth-score tree-stat">
        <p className="spec-title">{t("impact.tree_sequestration")}</p>
        <p className="spec-value">{treeVal}</p>
        <p className="spec-measure">{t("impact.days_to_absorb")}</p>
      </div>
    );
  }
};
